import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const ExternalLinkButton = (props) => {

    let marge = (props.icon && props.label) ? { marginRight: ".50rem" } : { marginRight: "0" };

    return (
        <a
            href={props.link}
            target="_blank"
            rel="noopener noreferrer"
            className={"btn " + props.className}
        >
            {props.icon &&
                <FontAwesomeIcon
                    icon={props.icon}
                    style={marge}
                />
            }
            {props.label}
        </a>
    );
}

ExternalLinkButton.propTypes = {
    link: PropTypes.string.isRequired
}

export default ExternalLinkButton